import { NgModule, Component } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { TrainingDomainsContentListComponent } from './training-domains-content-list/training-domains-content-list.component';
import { TrainingDomainsContentCreateComponent } from './training-domains-content-create/training-domains-content-create.component';

const routes: Routes = [
  {
    path: '',
    children: [
      {
        path: 'list-page',
        component: TrainingDomainsContentListComponent,
        data: {
          title: "List Page",
          breadcrumb: "List Page"
        }
      },
      {
        path: 'create-page',
        component: TrainingDomainsContentCreateComponent,
        data: {
          title: "Create Page",
          breadcrumb: "Create Page"
        }
      },
      {
        path: 'training-domains-content-create/:id',
        component: TrainingDomainsContentCreateComponent,
      }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class TrainingDomainsContentRoutingModule { }
